import { render, staticRenderFns } from "./stepTwo.vue?vue&type=template&id=2051bed3"
import script from "./stepTwo.vue?vue&type=script&lang=js"
export * from "./stepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports